<template>

	<div>

		<Modal 
			:class="{ 'keyword-graph': true }"
			:width="1600"
			:title="title2"
			:hasHeader="true"
			@close="close"
		>
			<template v-slot:header>
				<span 
					class="large-button add-investigation flip-colours mini"
					@click="showInvestigate=true"
				>Investigate</span>
				<FilterWrap 
					:outerPad="false" 
					@change="filterChange"
					@zoomChange="zoomChange"
					:showUpdateButton="showUpdateButton && hasSelected>0"
					:currentFrequency="frequency"
					:filters="filters"
					:key="filterKey"
					:needsUpdate="graphNeedsUpdate"
					:showFilterWeekly="true"
					:showFilterMonthly="true"
					class="keyword-graph"
				/>
			</template>

			<template v-slot:content>

				<div 
					:class="{'graph-wrap': true, hasList: showList === true }"
				>

					<GraphWrap 
						:chartdata="theChart.data" 
						:options="theChart.options" 
						:overlay="loadingChart"
						:height="mapSmallHeight"
						size="full"
						:key="chartKey"
						:noPad="true"
					>
						<Competitors
							:competitors="competitors2"
							:showCompetitors="showCompetitors2"
							v-if="showList"
							:showAdd="false"
							:key="cKey"
							@save="updateCompetitors"
						>
							<p>Competitors</p>
						</Competitors>
					</GraphWrap>

				</div><div class="list-items-wrap" v-if="showList">

					<input type="text" placeholder="Filter keywords" v-model="kwFilter">

					<span class="select" @click="selectAll" v-if="maxForStats>0" v-html="'select all ('+maxForStats+' max)'" />

					<span class="clear" @click="clearSelected" v-if="hasSelected>0">clear all</span>

					<div class="list-items" ref="kw-graph-list" id="n1">

						<div ref="kw-graph-list-wrap" id="n2">

							<div 
								class="list-item"
								v-for="(keyword) in keywordList" 
								:key="'keyword-'+keyword._id" 
							>
								<label>
									<input type="checkbox" v-model="selectedKeywords[keyword._id]" @click="showUpdateButton=true"> 
									<span>{{ keyword.keyword }}</span>
								</label>
							</div>

						</div>

					</div>

					<span v-if="keywordsPage < keywordsPages" @click="loadKeywords" class="load-more" v-html="loadMoreText" />

				</div>

			</template>

		</Modal>

		<Investigate
			v-if="showInvestigate"
			@close="closeInvestigateModal"
			:project="projectId"
			:theInvestigations="[{keyword:conflict?('Keyword Cannibalisation with '+title):title}]"
			type="conflict"
		/>

	</div>

	

</template>

<script>
import Vue from 'vue';
import { mapMutations } from 'vuex'
import ApiService from './../services/api.service'
import general from './../utils/general'
import GraphWrap from './Data/GraphWrap.vue'
import DateFilter from './Data/DateFilter.vue'
import FilterWrap from './FilterWrap.vue'
import Competitors from './Competitors.vue'
import Investigate from './Investigate.vue'
import Modal from './Display/Modal.vue'
export default {
	name: 'KeywordGraph',
	props: {
		preSelectedKeywords: {
			type: Array,
			default: function () { return [] }
		},
		preSelectedTags: {
			type: Array,
			default: function () { return [] }
		},
		startDate: {
			type: Date
		},
		endDate: {
			type: Date
		},
		showList: {
			type: Boolean,
			default: true
		},
		conflict: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: "Info"
		},
		competitors: {
			type: Object,
			default: () => { return {} }
		},
		showCompetitors: {
			type: Boolean
		},
		projectUrl: {
			type: String
		}
	},
	components: { GraphWrap, DateFilter, FilterWrap, Competitors, Investigate, Modal },
	watch: {
		kwFilter: function (newValue, oldValue) {
			
			if ( !this.loadingKeywords && newValue !== '' && this.keywordsPages > this.keywordsPage ) {

				let n1 = newValue.length, 
					k1 = this.allKeywords[this.allKeywords.length-1].keyword,
					n2 = k1.length;

				if ( n1 > n2 ) n1 = n2;

				let k2 = newValue.substr(0,n1);

				k1 = k1.substr(0,n1);

				if ( k1 < k2 ) {

					this.loadKeywords ();

				}

			}

		}
	},
	data() {

		return { 
			image: null,
			chartKey: 0,
			cKey: 0,
			loadingKeywords: false,
			showCompetitors2: false,
			competitors2: {},
			competitorDataSet: {},
			selectedKeywords: {},
			selectedTags: [],
			allKeywords: [],
			keywordsPage: 0,
			keywordsPages: 0,
			fetched: false,
			kwFilter: '',
			maxForStats: 0,
			filters: {},
			chartData: {},
			showUpdateButton: false,
			reloadingChart: false, 
			frequency: 'days',
			graphNeedsUpdate: new Date(),
			filterKey: 0,
			zoom: {
				min: 1,
				max: 100
			},
			showInvestigate: false,
			searchedKeywordCount: 0

		}

	},
	computed: { 

		investigationTips () {

			return 'Investigate conflicts with ' + this.title + ', last seen ' + general.dateFormat ('M jS \'y',this.endDate);

		},

		projectId () {

			return this.$route.params.projectId;

		},

		loadMoreText () {

			return this.loadingKeywords ? "Loading..." : "Load more";

		},

		title2 () {

			if ( this.conflict ) return "Keyword Cannibalisation: " + this.title;

			if ( this.allKeywords.length === 0 ) return "Loading...";

			if ( this.selectedKeywordArray.length === 0 ) {
				
				return "Please select a keyword"

			}

			let kId = this.selectedKeywordArray[0];

			if ( this.selectedKeywordArray.length === 1 ) {
				
				let k = this.allKeywords.find( k => k._id.toString() === kId.toString() );

				if ( k ) return k.keyword;
				else {

					return this.title;

				}

			}

			if ( this.selectedKeywordArray.length > 1 ) return this.selectedKeywordArray.length + " Keywords";

		},
		selectedKeywordArray () {

			let keywords = [];

			Object.keys( this.selectedKeywords ).forEach ( function (_id) {

				if ( this.selectedKeywords[_id] ) keywords.push(_id)

			}.bind(this));

			return keywords;

		},

		theChart () {

			let _this = this, 
				theChart = {
					data: {
						labels: [],
						datasets: []
					},
					loaded: false,
					options: {
						responsive: true,
						maintainAspectRatio: false,
						plugins: {
							tooltip: {
								callbacks: {
									label: function(context) {
										let dataset = context.dataset, 
											index = context.dataIndex;
										if ( !!dataset.isAnnotation ) {

											let max = 4;

											if ( dataset.labels[index].length > max ) {

												let labels = dataset.labels[index].slice(0,max);

												labels.push( '+' + ( dataset.labels[index].length - max ) + ' more, see events'  );

												return labels;

											}

											return dataset.labels[index];

										}
										if ( typeof dataset.tooltips !== 'undefined' && typeof dataset.tooltips[index] !== 'undefined' ) 
											return ' ' + dataset.label + ': ' + context.parsed.y + ' (' + dataset.tooltips[index] + ')';
										return ' ' + dataset.label + ': ' + context.parsed.y;
									},
									labelColor: function(context) {
										// Access the custom attribute 'showTooltipSquare' for the dataset
										const dataset = context.dataset;
										
										if ( !!dataset.isAnnotation ) {
											
											return {
												borderColor: dataset.pointBackgroundColor,
												backgroundColor: dataset.pointBackgroundColor
											};

										}
										
										return {
											borderColor: dataset.borderColor,
											backgroundColor: dataset.backgroundColor
										};
									}
								}
							}
						},
						scales: {
							x: {
								//min: this.zoom.min,
								//max: this.zoom.max,
								grid: {
									display: true,
									drawBorder: true,
									drawOnChartArea: false
								},
								ticks: {
									beginAtZero: true,
									autoSkip: true,
									maxTicksLimit: 20
								}
							},
							y: {
								type: 'linear',
								display: true,
								position: 'left',
								reverse: true,
								min: this.zoom.min,
								max: this.zoom.max,
								grid: {
									display: true,
									drawBorder: true,
									drawOnChartArea: false
								},
								title: {
									display: true,
									text: 'Position'
								},
								ticks: {
								}
							},
							y2: {
								type: 'linear',
								display: false,
								position: 'right',
								min: 1,
								max: 100,
								ticks: {
								},
								grid: {
									drawOnChartArea: false
								}
							}
						}
					}
				};

			if ( !this.conflict ) {

				theChart.options.plugins.legend = { 
					onClick: function (e, legendItem) {
						_this.competitors2[_this.competitorDataSet[legendItem.datasetIndex]] = legendItem.hidden;
						++_this.cKey;
					},
					labels: {
						filter: function(item, chart) {
							// Hide legend items for datasets with empty labels (annotations)
							return item.text && item.text.trim() !== '';
						}
					}
				}

			}
			else {

				theChart.options.plugins.legend = { 
					onClick: function (e, legendItem, legend) {
						console.log(legendItem);
						window.open( _this.projectUrl + legendItem.text );
					},
					onHover: function(e) {
						e.target.style.cursor = 'pointer';
					},
					labels: {
						filter: function(item, chart) {
							// Hide legend items for datasets with empty labels (annotations)
							return item.text && item.text.trim() !== '';
						}
					}
				}

				theChart.options.onHover = function(e, elements) {
					if (elements.length) e.native.target.style.cursor = 'pointer';
					else e.native.target.style.cursor = 'default';
				}

			}

			if ( Object.keys( this.chartData ).length > 0 ) {

				theChart.data.labels = this.chartData.labels;

				let ii = 0, annotationsDone = false;

				this.chartData.items.forEach ( function (kw) {

					if ( kw.annotations && !annotationsDone ) {

						annotationsDone = true;
						console.log('annotationsDone');
						let annotations = {
							project: [],
							global: []
						};

						kw.annotations.data.forEach( function (d) {

							let project = d === 2 ? d : null,
								global = d !== 2 ? d : null;

								annotations.project.push( project );
								annotations.global.push( global );

						});

						theChart.data.datasets.push({
							label: '',
							fill: false,
							tooltips: kw.tooltips,
							data: annotations.project,
							labels: kw.annotations.labels,
							yAxisID: 'y2',
							spanGaps: false,
							pointBackgroundColor: '#f1492a',
							pointBorderColor: '#f1492a',
							pointStyle: 'triangle', 
							borderColor: 'rgba(0, 0, 0, 0)', 
							isAnnotation: true,
							clip: false,
							showLine: false,
							pointRadius: 6
						});

						++ii;

						theChart.data.datasets.push({
							label: '',
							fill: false,
							tooltips: kw.tooltips,
							data: annotations.global,
							labels: kw.annotations.labels,
							yAxisID: 'y2',
							spanGaps: false,
							pointBackgroundColor: '#394559',
							pointBorderColor: '#394559',
							pointStyle: 'triangle', 
							borderColor: 'rgba(0, 0, 0, 0)', 
							isAnnotation: true,
							clip: false,
							showLine: false,
							pointRadius: 6
						});

						++ii;

					}

					theChart.data.datasets.push({
						label: kw.label,
						fill: false,
						backgroundColor: kw.color,
						borderColor: kw.color,
						data: kw.data,
						yAxisID: 'y',
						spanGaps: false,
						tension: 0.4
					});

					++ii;

					if ( this.showCompetitors2 && !!kw.competitors ) {

						Object.keys(kw.competitors).forEach ( function (competitorDomain) {

							let c = kw.competitors[competitorDomain], label = competitorDomain;

							if ( this.chartData.items.length > 1 ) label += ' ('+kw.label+')';

							theChart.data.datasets.push({
								label: label,
								fill: false,
								backgroundColor: c.color,
								borderColor: c.color,
								data: c.data,
								hidden: !this.competitors2[competitorDomain],
								yAxisID: 'y',
								borderDash: c.borderDash || [5,5],
								spanGaps: false,
								tension: 0.4
							});

							this.competitorDataSet[ii] = competitorDomain;

							++ii;

						}.bind(this));

					}

				}.bind(this))

				theChart.loaded = true;

			}

			return theChart;

		},

		hasGraphResults () {



		},

		hasSelected () {

			let count = 0;

			Object.keys( this.selectedKeywords ).forEach( function ( kwId ) {

				if ( this.selectedKeywords[kwId] ) ++count;

			}.bind(this));

			return count;

		},

		mapSmallHeight () {

			if ( !this.chartData.hasData ) return '120px';

			return null;

		},
		
		loadingChart () {

			if ( !this.theChart.loaded ) return true;

			if ( !this.chartData.hasData ) {
				
				return { text: this.searchedKeywordCount === 1 ? 'There is no data for this keyword at the moment.' : 'There is no data for these keywords at the moment.' };

			}

			if ( !this.fetched || this.reloadingChart ) {

				return { text: 'Loading chart...' };

			}

			if ( this.fetched && this.theChart.data && !this.theChart.data.labels.length ) {

				return { text: 'No results' };

			}

			return false;

		},

		keywordList () {

			let keywords = [];

			this.allKeywords.forEach ( function (kw) {

				if ( this.kwFilter === '' || kw.keyword.search(this.kwFilter) >= 0 ) {

					keywords.push(kw);

				}

			}.bind(this));

			return keywords;

		}

    },
	mounted() {

		this.preSelectedKeywords.forEach ( function (_id) {

			Vue.set( this.selectedKeywords, _id, true );

		}.bind(this));

		this.selectedTags = this.preSelectedTags;
		if ( this.endDate ) Vue.set( this.filters, 'endDate', this.endDate );
		this.loadChart();
		this.showCompetitors2 = this.showCompetitors;
		this.competitors2 = JSON.parse( JSON.stringify( this.competitors ) );
		if ( this.showList ) {
			this.loadKeywords();
		}

	},

	methods: {

		...mapMutations('general',['updateLoadingText']),

		closeInvestigateModal (info) {

			general.modalClose();

			this.showInvestigate = false;

		},

		updateCompetitors (info) {

			if ( info.competitors ) Vue.set( this, 'competitors2', info.competitors );
			Vue.set( this, 'showCompetitors2', info.showCompetitors );

		},

		filterChange (info) {

			if ( info.frequency !== 'months' && info.startDate ) {

				let difference = info.endDate.getTime() - info.startDate.getTime();

				let TotalCheck = Math.ceil(difference / (1000 * 3600 * 24)), updated = false;

				if ( info.frequency === 'days' && TotalCheck > 90 ) {

					this.frequency = 'weeks';
					info.frequency = 'weeks';
					++this.filterKey;
					updated = true;
					
				}

				TotalCheck /= 7;

				if ( info.frequency === 'weeks' && TotalCheck > 90 ) {

					this.frequency = 'months';
					info.frequency = 'months';
					++this.filterKey;
					this.$snotify.warning("The filter has been updated to show results by month for this date range.", 'Update Graph');

				}
				else if ( updated ) {

					this.$snotify.warning("The filter has been updated to show results by week for this date range.", 'Update Graph');

				}

			}

			this.filters = info;
			this.loadChart ();
			this.showUpdateButton = false;

		},

		zoomChange (zoom) {
			
			Vue.set( this, 'zoom', zoom );

		},

		selectAll () {

			let count = 0;

			Object.keys( this.selectedKeywords ).forEach( function ( kwId ) {

				if ( this.selectedKeywords[kwId] ) ++count;

			}.bind(this));

			this.keywordList.forEach( function ( kw ) {

				if ( count < this.maxForStats && typeof this.selectedKeywords[kw._id] === 'undefined' || this.selectedKeywords[kw._id] === false ) {

					++count;
					Vue.set( this.selectedKeywords, kw._id, true );

				}

			}.bind(this));

			if ( this.hasSelected > 0 ) this.showUpdateButton = true;

			this.$refs['kw-graph-list'].scrollTop = 0;						

		},

		clearSelected() {

			this.selectedKeywords = {};

		},

		createImage(e) {

			let canvas = document.querySelector('.keyword-graph #line-chart'), 
				image = new Image();
			image.src = canvas.toDataURL("image/png");
			this.image = image.src;

		},

		close() {

			this.$emit('close');

		},

		loadChart () {

			if ( this.selectedKeywordArray.length === 0 ) {

				this.$snotify.error("Please select at least 1 keyword", 'Update Graph');
				return;

			}
			
			let i = 0, 
				queryString = '';

			if ( this.selectedKeywordArray.length === 1 ) {

				this.filters.average = false;

			}
			
			Object.keys(this.filters).forEach(function(k) {

				if ( this.filters[k] ) {

					let a = i > 0 ? '&' : '?', go = true;

					let val = ( k === 'startDate' || k === 'endDate' ) ? this.filters[k].getFullYear() + '-' + ( this.filters[k].getMonth() + 1 ) : this.filters[k];

					if ( k === 'startDate' || k === 'endDate' ) {

						let m = this.filters[k].getMonth() + 1, d = this.filters[k].getDate();

						if ( m < 10 ) m = '0' + m;
						if ( d < 10 ) d = '0' + d;

						val = this.filters[k].getFullYear() + '-' +  m + '-' + d;

					}
					else if ( k === 'zoom' ) {

						this.zoom = val;
						go = false;

					}
					else {

						if ( val === true ) val = 1;
						if ( val === false ) go = false;

					}

					if ( go ) {

						queryString += a + k + '=' + val;
						++i;

					}

				}

			}.bind(this));

			let url = 'stats/keywords/' + this.$route.params.projectId + '/' + this.selectedKeywordArray.join('|') + queryString;

			if ( this.conflict ) {

				url = 'stats/conflicts/' + this.$route.params.projectId + '/' + this.selectedKeywordArray[0] + queryString;

			}

			this.reloadingChart = true;

			ApiService.get( url, null, 'KeywordGraph' )
			.then( function( info ) {

				Vue.set( this.theChart.data, 'labels', info.data.labels );

				let datasets = [];

				this.searchedKeywordCount = this.selectedKeywordArray.length;

				info.data.items.forEach ( function (kw) {

					datasets.push({
						label: kw.label,
						fill: false,
						backgroundColor: kw.color,
						borderColor: kw.color,
						data: kw.data,
						yAxisID: 'y',
			          	spanGaps: false
				    });

				}.bind(this))

				Vue.set( this, 'chartData', info.data );

				if ( this.conflict ) {

					Vue.set( this.chartData, 'hasData', true );

				}
				
				this.fetched = true;
				this.reloadingChart = false;
				Vue.set( this, 'frequency', info.data.frequency );

				if ( this.filters.frequency && this.filters.frequency !== info.data.frequency ) {

					this.$snotify.warning("The frequency was changed from " + this.filters.frequency + ' to ' + info.data.frequency + ' due to low data.', 'Frequency Change');

				}

				Vue.set( this.filters, 'frequency', info.data.frequency );

				let sD = info.data.startDate.split('T')[0].split('-'), eD = info.data.endDate.split('T')[0].split('-');

				sD = new Date( sD[0], parseInt(sD[1])-1, sD[2], 0, 0, 0 );

				eD = new Date( eD[0], parseInt(eD[1])-1, eD[2], 23, 59, 59 );

				Vue.set( this.filters, 'startDate', sD );

				Vue.set( this.filters, 'endDate', eD );

				++this.filterKey;

			}.bind(this))
			.catch( function(err) {}.bind(this));

		},

		loadKeywords () {

			if ( this.loadingKeywords ) return;

			++this.keywordsPage;
			this.loadingKeywords = true;

			let h = this.$refs['kw-graph-list-wrap'].offsetHeight;
			
			ApiService.get( 'keywords/'+this.$route.params.projectId + '?page=' + this.keywordsPage )
			.then( function( info ) {

				info.data.items.forEach ( function (kw) {

					let keyword = typeof kw.keyword === 'string' ? kw.keyword : kw.keyword.keyword;

					this.allKeywords.push( { _id: kw._id, keyword: keyword } );

				}.bind(this))

				this.maxForStats = info.data.maxForStats;

				this.keywordsPage = info.data.page;
				this.keywordsPages = info.data.pages;

				this.loadingKeywords = false;
				let t = this;
				setTimeout( function () { t.$refs['kw-graph-list'].scrollTop = h; }, 300 );

			}.bind(this))
			.catch( function(err) {

				this.loadingKeywords = false;

			}.bind(this));

		}
	}
}
</script>

<style lang="less" scoped>
@import './../assets/css/less/_helper.less';
@import './../assets/css/less/_settings.less';
.modal {
	.modal-inner-scroll {
		position: static;
	}
}
.add-investigation {
	margin: 10px auto;
    display: block;
    width: 176px;
}
.keyword-graph {

	.graph-wrap {

		width: 100%;

		.info-panel {

			padding: 0;
			border: none;

		}

	}

	.filter-wrap {

		padding: 10px 20px;
		background-color: #fff;

	}

	.list-items-wrap {

		display: none;
		width: 20%;
		vertical-align: top;
		padding: 0 0 0 20px;
    	position: relative;

    	.load-more {

    		display: inline-block;
    		color: @formDefaultColour;
    		padding-top: 5px;
    		font-size: 14px;
    		cursor: pointer;

    	}

		[type=text] {

			border:none;
			outline: none;
			border-bottom: 2px solid @bgGrey;
			padding: 0 0 4px 4px;
    		margin-bottom: 6px;
    		width: 100%;

		}

		.clear, .select {

			cursor: pointer;
			position: absolute;
			font-size: 12px;
			top: 28px;
			right: 0;
			color:@red;

			&:hover {

				color: #000;

			}

		}

		.select {

			right:auto;
			left: 25px;

		}

		.list-items {

			max-height: 60vh;
    		overflow-y: auto;
    		margin-top: 12px;

			.list-item {

				padding: 2px 4px;
				font-size: 13px;

				&:nth-child(even) {

					background-color:@bgGrey;

				}

				&:hover {

					background-color:rgba(0,0,0,0.1);

					&:nth-child(even) {

						background-color:rgba(0,0,0,0.1);

					}
					
				}

				label {

					position: relative;
					display: block;
					padding-left: 17px;
					cursor: pointer;

					[type=checkbox] {

						vertical-align: top;
						margin-top: 0;
	    				margin-left: 0;
	    				position: absolute;
					    top: 2px;
					    left: 0;

					}

					span {

						display: inline-block;
						vertical-align: top;

					}

				}

			}

		}

	}

}
@media screen and (min-width: 1024px) {

	.add-investigation {

		display: inline-block;
		margin: 0;
		position: absolute;
		z-index: 4;
		top: 16px;
		right: 60px;
		width: auto;

	}

	.keyword-graph {

		.modal-wrap {

			padding-left: 20px;

		}

		.graph-wrap {

			display: inline-block;
			vertical-align: top;

			&.hasList {

				width: 80%;

			}

		}

		.list-items-wrap {

			display: inline-block;

			.list-items {

				height: 50vh;

			}

		}

		.modal-inner {

			position: relative;

		}

		.modal-inner-scroll {

			padding-top: 50px;

		}

	}

}
</style>